<template>
  <section class="upc-search">
    <h2 class="title">Individual Search by {{ searchType }}</h2>

    <AlbumSearch
      @search-individual="findAlbumById($event)"
      @change-type="searchType = $event"
    />

    <div
      v-if="store.individualItem"
      class="albums-info"
    >
      <AlbumCard
        v-for="(album, provider) in store.individualItem"
        :key="album.upc"
        :album="album"
        :provider="provider"
        @sync-album="syncAlbum($event)"
      />
    </div>
  </section>
</template>

<script>
import { ref } from 'vue'
import { useAlbumStore } from '@/stores/album'
import AlbumCard from '@/components/AlbumCard'
import AlbumSearch from '@/components/AlbumSearch'

export default {
  name: 'AlbumsIndividual',

  components: { AlbumSearch, AlbumCard },

  setup() {
    const store = useAlbumStore()
    const searchType = ref('UPC')

    return {
      store,
      searchType
    }
  },

  methods: {
    /**
     * Search album by (UPC-ISRC) depends on user selection
     * @param data => { type: Boolean, value: String }
     */
    findAlbumById(data) {
      this.store.findAlbumById(data)
    },

    /**
     * Call syncAlbum action from store and
     * show notify alert according request response
     * @param data => { provider: String, upc: String }
     */
    syncAlbum(data) {
      this.store.syncAlbum(data)
    }
  },
}
</script>

<style lang="scss">
.albums-info {
  display: flex;
  width: 900px;
  margin: 3em auto;
  flex-direction: column;
}
</style>
